import { productsFields } from './fragments/products-fields'
import { paginationVariables } from './variables/pagination-variables'
import { filtersVariables } from './variables/filters-variables'
import { storeVariables } from './variables/store-variables'
import { metricDataVariables } from './variables/metric-data-variables'

import { searchProductsWithMetricsDataParams } from './params/search-products-with-metric-data-params'

export const querySearchProductsForStore = /* GraphQL */ `
  query searchProductsForStore(
    $term: String!,
    ${paginationVariables},
    ${filtersVariables},
    ${storeVariables},
    ${metricDataVariables}
  ) {
    seller(id: $seller_id, ownerID: $owner_id) {
      search(products: ${searchProductsWithMetricsDataParams}) {
        products(first: $first, after: $after) {
          total
          edges {
            cursor
            node {
              ...productsFields
            }
          }
        }
      }
    }
  }

  ${productsFields}
`
